import { GET_USER_FROM_SESSION, NOTIFICATION_SETTINGS } from 'actions/types';

let profile = null;
const initialState = null;

/**
  @description Stores authenticated user details in redux state
  @param {{} | null} state
  @param {{}} action
  @returns {{} | null}
 */
function user(state = initialState, action) {
  const { type, payload } = action;
  if (type === `${GET_USER_FROM_SESSION}_FAILURE`) {
    profile = null;
    return profile;
  }
  if (type === `${GET_USER_FROM_SESSION}_SUCCESS`) {
    profile = payload;
    return profile;
  }
  if (type === `${NOTIFICATION_SETTINGS}_SUCCESS`) {
    const { updatedValues } = payload;
    if (updatedValues) {
      const { emails } = updatedValues;
      const data = {
        ...profile,
        notification_settings: { ...profile.notification_settings, emails },
      };
      profile = data;
      return profile;
    }
  }
  return state;
}

export default user;
